import './CategoriesList.css';
import localProductIcon from '../../img/local-product-icon.svg';
import ProductThumbnails from '../ProductThumbnails/ProductThumbnails';
import electronicProductIcon from '../../img/electronic-icon.svg';
import propertyProductIcon from '../../img/properties-icon.svg';
import {Link} from 'react-router-dom';
import {useEffect, useState} from 'react';

const CategoriesList = () => {

    const [localProductData, setLocalProductData] = useState([]);
    const [electronicData, setElectronicData] = useState([]);
    const [propertyData, setPropertyData] = useState([]);

    const formatNumber = (n, p, ts, dp) => {
        var t = [];
        // Get arguments, set defaults
        if (typeof p == 'undefined') p = 2;
        if (typeof ts == 'undefined') ts = '.';
        if (typeof dp == 'undefined') dp = ',';

        // Get number and decimal part of n
        n = Number(n).toFixed(p).split('.');

        // Add thousands separator and decimal point (if requied):
        for (var iLen = n[0].length, i = iLen ? iLen % 3 || 3 : 0, j = 0; i <= iLen; i += 3) {
            t.push(n[0].substring(j, i));
            j = i;
        }
        // Insert separators and return result
        return t.join(ts) + (n[1] ? dp + n[1] : '');
    }

    const fetchLocalProduct = async () => {
        const fetchLocalProductData = await fetch("https://backend-markopedia.herokuapp.com/api/product/produklokal", {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json());
        console.log(fetchLocalProductData)
        setLocalProductData(fetchLocalProductData.data);
    }

    const fetchElectronic = async () => {
        const fetchElectronicData = await fetch("https://backend-markopedia.herokuapp.com/api/product/elektronik", {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json());
        console.log(fetchElectronicData)
        setElectronicData(fetchElectronicData.data);
    }

    const fetchProperty = async () => {
        const fetchPropertyData = await fetch("https://backend-markopedia.herokuapp.com/api/product/properti", {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json());
        console.log(fetchPropertyData)
        setPropertyData(fetchPropertyData.data);
    }

    useEffect(() => {
        fetchLocalProduct();
        fetchElectronic();
        fetchProperty();
    }, [])

    const localProductItemList = localProductData.map(x => {
        return (
            <ProductThumbnails 
                key={x.id}
                id={x.id}
                imageUrl={x.imageUrl}
                productName={
                    x.name.length > 35 ? 
                    x.name.substring(0, 25)+"..."
                    :
                    x.name
                } 
                price={formatNumber(x.price, 0)}
            />
        )   
    })

    const electronicItemList = electronicData.map(x => {
        return (
            <ProductThumbnails 
                key={x.id}
                id={x.id}
                imageUrl={x.imageUrl}
                productName={
                    x.name.length > 35 ? 
                    x.name.substring(0, 25)+"..."
                    :
                    x.name
                } 
                price={formatNumber(x.price, 0)}
            />
        )   
    })
    
    const propertyItemList = propertyData.map(x => {
        return (
            <ProductThumbnails 
                key={x.id}
                id={x.id}
                imageUrl={x.imageUrl}
                productName={
                    x.name.length > 35 ? 
                    x.name.substring(0, 25)+"..."
                    :
                    x.name
                } 
                price={formatNumber(x.price, 0)}
            />
        )   
    })

    return(
        <div className="categorieslist-wrapper">
            <h4 className="categorieslist-maintitle" >Beli berdasarkan kategori</h4>
            <div className="categories-localproduct">
                <div className="category-title">    
                    <img src={localProductIcon}></img>
                    <span className="category-title-main">Produk Lokal</span>
                </div>
                <div className="category-items">
                {localProductItemList}    
                </div>
            </div>
            <div className="categories-electronic">
                <div className="category-title">    
                    <img src={electronicProductIcon}></img>
                    <span className="category-title-main">Produk Elektronik</span>
                </div>
                <div className="category-items">
                {electronicItemList}  
                </div>
            </div>
            <div className="categories-properties">
                <div className="category-title">    
                    <img src={propertyProductIcon}></img>
                    <span className="category-title-main">Produk Properti</span>
                </div>
                <div className="category-items">
                {propertyItemList}  
                </div>
            </div>
        </div>
    )
};

export default CategoriesList;